export function useSite() {
  const siteName = useState('siteName', () => 'SOS Restoration')

  return {
    siteName,
  }
}
